function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { generateDocumentFile } from "./generateDocumentFile";
export var downloadDocumentFile = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var html, file, options, content, pdf, url;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    html = param.html, file = param.file, options = param.options;
                    _ctx.next = 3;
                    return generateDocumentFile({
                        exportOptions: options,
                        html: html,
                        returnType: "blob"
                    });
                case 3:
                    content = _ctx.sent;
                    pdf = new window.Blob([
                        content
                    ], {
                        type: file === null || file === void 0 ? void 0 : file.mime
                    });
                    url = window.URL.createObjectURL(pdf);
                    window.open(url, "".concat(file.name, ".").concat(file === null || file === void 0 ? void 0 : file.ext));
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function downloadDocumentFile(_) {
        return _ref.apply(this, arguments);
    };
}();
